
module.exports = {
    myHost: {
       'host':'https://api-a19.smicee.com',
    }
};
